const namespace = "ringBuyIn";

export const BANKROLL = `${namespace}.bankroll`;
export const SESSION_LIMIT = `${namespace}.sessionLimit`;
export const TOP_UP = `${namespace}.topUp`;
export const DEPOSIT = `${namespace}.deposit`;
export const PLAY = `${namespace}.play`;
export const OK = `${namespace}.ok`;
export const DEPOSIT_MESSAGE = `${namespace}.depositMessage`;
